import { render, staticRenderFns } from "./AvailabilityText.vue?vue&type=template&id=1c665084&"
import script from "./AvailabilityText.vue?vue&type=script&lang=js&"
export * from "./AvailabilityText.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports